import { format } from 'date-fns';
import { map, omit, values } from 'lodash';

/**
 * Maps one New Order form prescription to the createPomOrder `prescriptionInput` shape.
 * POM-6360: no provider address is sent — core uses the practice address for the prescriber.
 */
const buildPrescriptionOrderInput = (prescription) =>
  omit(
    {
      ...prescription,
      providerInput: omit(prescription.providerInput, 'address'),
      quantity: parseInt(prescription.quantity, 10),
      dateWritten: prescription.dateWritten,
      dispenseAsWritten: !!prescription.dispenseAsWritten,
      attachments: map(values(prescription.attachments), (attachment) => ({
        fileKey: attachment.key,
        fileName: attachment.filename,
      })),
      expirationDate:
        prescription.expirationDate && format(prescription.expirationDate, 'yyyy-MM-dd'),
    },
    // packSizeValue/packSizeUnit/formAlias are carried on prescriptionInput purely for the
    // Review step's display (POM catalog fields, not part of the order-creation contract) —
    // strip them so the mutation only ever receives fields it actually accepts.
    ['providerData', 'packSizeValue', 'packSizeUnit', 'formAlias']
  );

export const NO_PRODUCTS_AVAILABLE_MESSAGE = 'No products are currently available for ordering';

export const hasNoOrderableCatalog = (partnerCatalog) =>
  Array.isArray(partnerCatalog) && partnerCatalog.length === 0;

export default buildPrescriptionOrderInput;
